import ErrorBoundary from 'components/ErrorBoundary'
import React, { useEffect } from "react";
import { Card, CardBody, CardHeader, CardTitle, Col, Nav, Row } from 'reactstrap'
import Download from "../../../assets/icon/Download-Icon3.svg";
import CTooltip from "react-tooltip-lite";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Line } from "react-chartjs-2";
import DownloadCSVButton from './DownloadCsv';
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

ChartJS.register(ArcElement, Tooltip, Legend);

const plugin = {
  beforeInit(chart) {
    // Get reference to the original fit function
    const originalFit = chart.legend.fit;

    // Override the fit function
    chart.legend.fit = function fit() {
      // Call original function and bind scope in order to use `this` correctly inside it
      originalFit.bind(chart.legend)();
      // Change the height as suggested in another answers
      this.height = this.height + 15;
    };
  },
};

export const options = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      ticks: {
        color: "#000",
        size: 15,
      },
    },
    y: {
      ticks: {
        callback: function (value, index, ticks) {
          return "$" + value;
        },
      },
      border: {
        display: false,
      },
    },
  },
  plugins: {
    legend: {
      position: "top",
      labels: {
        padding: 15,
        usePointStyle: true,
        pointStyle: "rect",
        color: "#707070",
        font: {
          size: 14,
          weight: "600",
        },
      },
      align: "start",
    },
    tooltip: {
      enabled: true,
      intersect: true,
      callbacks: {
        label: function (context) {
          // let value = context.raw;
          // const formattedAmount = Math.floor(value).toLocaleString('en-US');
          // return 'Net 340B Savings : $' + formattedAmount;


          let num = context.raw;
          let formatter = new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
          let formatted = formatter.format(num);
          // console.log(formatted);
          return 'Net 340B Savings : $' + formatted;
        },

      },
    },
  },
};
const Programover = (props) => {
  const { months, netSavings } = props
  const copyData = {
    labels: months,
    datasets:
      [
        {
          label: "Net 340B Savings",
          data: netSavings,
          borderColor: "#702C62",
          backgroundColor: "#702C62",
          pointRadius: 3.5,
        },

      ],
  };


  return (
    <div>
      <ErrorBoundary>
        <Card className="p-3 h-100 border-0 shadow-top">

          <CardHeader className="border-0 bg-white px-0 pt-0" style={{ paddingBottom: "0px" }}>
            <Row className="align-items-center">
              <Col>
                <CTooltip
                  content={
                    <div className="tip-list-info">
                      <p>
                        The net savings (Total Paid - Dispensing Fee - 340B Drug Cost - RCS Fee) on approved or higher status claims.
                      </p>
                    </div>
                  }
                >
                  <CardTitle className="f-20 font-weight-600 dashboard-headings">
                    <div className="d-flex justify-content-between align-items-center top_left_hed pb-1 graph-headings">
                      Net 340B Savings
                      <DownloadCSVButton
                        monthsdata={months}
                        valuedata1={netSavings}
                        heading1={["Month", "340B Savings",]}
                        filenamedata={"340BSavings"}
                      />
                      {/* <img src={Download} /> */}
                    </div>
                  </CardTitle>
                </CTooltip>
              </Col>
              <Col xs="auto" >
                <Nav className="widget-tabs"></Nav>
              </Col>
            </Row>
          </CardHeader>
          <CardBody className="dashboard-chart-body p-0">

            <div className="chat-container">
              <Line options={options} data={copyData} plugins={[plugin]} />
            </div>
          </CardBody>
        </Card>
      </ErrorBoundary>
    </div>
  )
}

export default Programover